(function injectModalStyle() {
  if (document.getElementById("modal-style")) return;

  const style = document.createElement("style");
  style.id = "modal-style";
  style.innerHTML = `
    .swal2-popup.modal-content {
      border-radius: 16px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      background-color: #ffffff;
      padding: 20px;
      font-family: 'Arial', sans-serif;
      max-width: 800px;
    }
    .lotes-scroll-container {
      max-height: 300px;
      overflow-y: auto;
      margin-bottom: 12px;
    }
    .lotes-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
    }
    .lotes-table th,
    .lotes-table td {
      padding: 8px;
      text-align: left;
      border-bottom: 1px solid #ddd;
    }
    .lotes-total {
      font-weight: bold;
      color: #7c5b38;
      font-size: 13px;
      margin-top: 8px;
    }
    .swal2-confirm {
      background-color: #7c5b38 !important;
      color: white !important;
      border-radius: 6px !important;
      padding: 10px 18px !important;
    }
    .swal2-cancel {
      background-color: transparent !important;
      color: #7c5b38 !important;
      border: 1px solid #7c5b38 !important;
      border-radius: 6px !important;
      padding: 10px 18px !important;
      margin-left: 10px;
    }
    .swal2-actions {
      justify-content: flex-end !important;
      display: flex !important;
      gap: 10px;
    }
  `;
  document.head.appendChild(style);
})();

function getProductFormI18n() {
  const i18n = window.productFormI18n || {};
  const t = (key, fallback = "") => {
    const v = i18n[key];
    return typeof v === "string" && v.length ? v : fallback;
  };
  return { i18n, t };
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.selectedVariant = null;

        this.variants = JSON.parse(
          document.getElementById("product-variants-data").textContent
        );

        this.updateSelectedVariant();

        // Atualizar a variante selecionada
        this.variantIdInput.addEventListener(
          "change",
          this.updateSelectedVariant.bind(this)
        );
      }

      updateSelectedVariant() {
        const selectedId = this.variantIdInput.value;
        this.selectedVariant = this.variants.find(
          (v) => v.id === parseInt(selectedId)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const { t } = getProductFormI18n();

        console.log(
          "Formulário enviado, variante selecionada:",
          this.selectedVariant
        );

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (!this.selectedVariant) {
          console.error("Nenhuma variante selecionada");
          return;
        }

        const sku = this.selectedVariant?.sku;
        const { tipoProduto, unidadeMedida } = getTipoInfo(sku);

        console.log("[SUBMIT] SKU:", sku);
        console.log("[SUBMIT] Tipo do produto:", tipoProduto);
        console.log("[SUBMIT] Unidade de medida:", unidadeMedida);

        if (tipoProduto === "SOB_MEDIDA") {
          console.log(
            "[SUBMIT] Produto sob medida - abrindo modal customizado"
          );
          this.openCustomModal();
          return;
        }

        console.log("[SUBMIT] Fluxo normal de adicionar ao carrinho");
        this.addToCart();
      }

      openCustomModal() {
        const { t } = getProductFormI18n();
        Swal.fire({
          title: t("madeToOrderTitleHtml", "<strong>Tapete Sob Medida</strong>"),
          icon: "info",
          width: "40rem",
          html: `
            <p>${t(
              "madeToOrderIntroHtml",
              "A produção de tapetes sob medida passa pela análise e aprovação de nossa equipe. Por favor, preencha as informações abaixo."
            )}</p>
            <form id="customForm">
              <div class="form-group">
                <label for="format">${t("formatLabel", "Formato")}</label>
                <select id="format" name="format" required>
                  <option value="" disabled selected>${t("chooseFormatPlaceholder", "Escolha o formato")}</option>
                  <option value="Retangular">${t("formatRectangular", "Retangular")}</option>
                  <option value="Redondo">${t("formatRound", "Redondo")}</option>
                  <option value="Quadrado">${t("formatSquare", "Quadrado")}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="border">${t("borderLabel", "Borda")}</label>
                <select id="border" name="border" required>
                  <option value="" disabled selected>${t("chooseBorderPlaceholder", "Escolha o acabamento da borda")}</option>
                  <option value="overlock">${t("borderOverlock", "Overlock 4 lados")}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="width">${t("widthLabel", "Largura (m)")}</label>
                <input type="number" id="width" name="width" placeholder="${t("widthPlaceholder", "Largura em metros")}" required min="0.01" step="0.01">
              </div>
              <div class="form-group">
                <label for="length">${t("lengthLabel", "Comprimento (m)")}</label>
                <input type="number" id="length" name="length" placeholder="${t("lengthPlaceholder", "Comprimento em metros")}" required min="0.01" step="0.01">
              </div>
            </form>
          `,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonColor: "#968575",
          focusConfirm: false,
          confirmButtonText: t("confirmButtonHtml", `<i class="fa fa-thumbs-up"></i> Confirmar`),
          cancelButtonText: t("cancelButtonHtml", `<i class="fa fa-thumbs-down"></i> Cancelar`),
          preConfirm: () => {
            const width = parseFloat(document.getElementById("width").value);
            const length = parseFloat(document.getElementById("length").value);
            const format = document.getElementById("format").value;
            const border = document.getElementById("border").value;

            if (width && length && format && border) {
              // Calcula a área em metros quadrados
              const area = width * length;

              // Calcula o preço baseado na área
              const valorTotal = area * (this.selectedVariant.price / 100); // Shopify armazena em centavos

              console.log(
                "Área: " + area + "m², Valor Total: R$" + valorTotal.toFixed(2)
              );

              return { width, length, format, border, valorTotal };
            } else {
              Swal.showValidationMessage(
                t("validationRequiredFields", "Por favor, preencha todos os campos obrigatórios.")
              );
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.addToCartWithCustomOptions(result.value);
          }
        });
      }

      addToCart() {
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }

            this.cart.renderContents(response);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            });
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      addToCartWithCustomOptions(customData) {
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: this.selectedVariant.id,
            quantity: 1,
            properties: {
              Formato: customData.format,
              Borda: customData.border,
              Largura: `${customData.width}m`,
              Comprimento: `${customData.length}m`,
            },
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status && response.status === 422) {
              this.handleErrorMessage(response.description);
              return;
            }

            // Atualizar o carrinho após adicionar item customizado
            if (this.cart) {
              // Recarregar as seções do carrinho
              const sectionsToRender = this.cart
                .getSectionsToRender()
                .map((section) => section.id);

              fetch(
                `${window.location.pathname}?sections=${sectionsToRender.join(
                  ","
                )}`
              )
                .then((response) => response.json())
                .then((sections) => {
                  // this.cart.renderContents(sections);

                  setTimeout(() => {
                    window.location.reload();
                  }, 500);

                  // Abrir o drawer após atualização
                  // const cartDrawerToggle = document.querySelector(
                  //   '[aria-controls="CartDrawer"]'
                  // );
                  // if (cartDrawerToggle) {
                  //   cartDrawerToggle.click(); // dispara o drawer
                  // } else {
                  //   document.dispatchEvent(
                  //     new CustomEvent("cart:updated", {
                  //       detail: { cart: response },
                  //     })
                  //   );
                  // }
                });
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: this.selectedVariant.id,
              cartData: response,
            });
          })
          .catch((error) => {
            console.error("Erro ao adicionar produto customizado:", error);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
